import { Coins } from "lucide-react";

export default function CurrencyFormatHint() {
  return (
    <div className="flex items-center gap-2 text-xs text-gray-500">
      <Coins className="h-3.5 w-3.5 flex-shrink-0" />
      <span>
        Formato argentino: punto para miles (1.234) y coma para decimales (,56). 
        Ejemplos: 1.234,56 pesos • 12.000 pesos • 9,99 pesos
      </span>
    </div>
  );
}